export const SEARCH_COMPANY = 'SEARCH_COMPANY';
export const SEARCH_COMPANY_EMAIL = 'SEARCH_COMPANY_EMAIL';

export const SEARCH_COMPANY_ROLES = 'SEARCH_COMPANY_ROLES';
export const SEARCH_COMPANY_GROUPS = 'SEARCH_COMPANY_GROUPS';
export const GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS';
export const COMPANY_TEMPLATE_LIST = 'COMPANY_TEMPLATE_LIST';
export const SEARCH_COMPANY_REQUIRED_FIELDS = 'SEARCH_COMPANY_REQUIRED_FIELDS';
export const SEARCH_COMPANY_TAGS = 'SEARCH_COMPANY_TAGS';
export const GET_DOCUMENT_FIELDS = 'GET_DOCUMENT_FIELDS';

export const GET_COLLABORA_EDIT_DATA = 'GET_COLLABORA_EDIT_DATA';
export const GET_HAS_SEEN_NEW_UPLOAD = 'GET_HAS_SEEN_NEW_UPLOAD';

export const GET_COMPANY_USED_DOCS_COUNT = 'GET_COMPANY_USED_DOCS_COUNT';

export const GET_DOC_CATEGORIES_QUERY = 'GET_DOC_CATEGORIES_QUERY';
export const GET_DOC_CATEGORY_LIST_INFINITY_QUERY =
    'GET_DOC_CATEGORY_LIST_INFINITY_QUERY';
export const GET_DOC_CATEGORY_SEARCH_QUERY = 'GET_DOC_CATEGORY_SEARCH_QUERY';
export const GET_DOC_CATEGORIES_BY_IDS_QUERY =
    'GET_DOC_CATEGORIES_BY_IDS_QUERY';

export const GET_CREATION_TEMPLATE_LIST = 'GET_CREATION_TEMPLATE_LIST';
export const FETCH_TEMPLATE_PREVIEW = 'FETCH_TEMPLATE_PREVIEW';

export const POST_CREATION_TEMPLATE = 'POST_CREATION_TEMPLATE';
export const GET_TEMPLATE_COLLABORA_DATA = 'GET_TEMPLATE_COLLABORA_DATA';
export const GET_DRAFT_TEMPLATE_COLLABORA_DATA =
    'GET_DRAFT_TEMPLATE_COLLABORA_DATA';

export const GET_DOCS_INDEXATION_STATUS = 'GET_DOCS_INDEXATION_STATUS';

export const GET_DOCUMENT_DRAFT_LIST = 'GET_DOCUMENT_DRAFT_LIST';

export const GET_EMPLOYEE_SESSIONS_LIST = 'GET_EMPLOYEE_SESSIONS_LIST';

// CACHE ETC
export const REQUEST_DELAY_MS = 300;
export const CACHE_TIME_MS = 60 * 1000;
